import { IonSkeletonText } from "@ionic/react";
import { memo } from "react";

export const SelectedMealListPlaceholder = memo(
  function SelectedMealListPlaceholder() {
    return (
      <>
        <div className="w-full flex items-center gap-4">
          <IonSkeletonText animated className="w-30 h-30 rounded-lg" />
          <div className="flex-1 flex flex-col gap-2">
            <IonSkeletonText animated className="w-3/5 h-5 rounded-md" />
            <IonSkeletonText animated className="w-2/5 h-4 rounded-md" />
          </div>
        </div>
        <div className="w-full flex items-center gap-4">
          <IonSkeletonText animated className="w-30 h-30 rounded-lg" />
          <div className="flex-1 flex flex-col gap-2">
            <IonSkeletonText animated className="w-1/2 h-5 rounded-md" />
            <IonSkeletonText animated className="w-1/3 h-4 rounded-md" />
          </div>
        </div>
      </>
    );
  },
);
